function gaNode(pluginConfig) {
  return {
    name: 'google-analytics',
    initialize: function initialize(_ref) {// console.log('has no server implementation yet')

      _ref.config;
    }
  };
}

/* This module will shake out unused code + work in browser and node 🎉 */

var index = gaNode;
/* init for CDN usage. globalName.init() */

var init = gaNode;

export { index as default, init };
